import '../App.css'; // path may vary depending on your structure
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import api from '../api';
import logo from '../assets/wsdot_band.png';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { Link } from 'react-router-dom';

import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';

import { APIProvider, Map, AdvancedMarker, Pin, InfoWindow } from '@vis.gl/react-google-maps';

const comingSoonSites = [];

const DefaultIcon = L.icon({
  iconUrl: markerIcon,
  iconRetinaUrl: markerIcon2x,
  shadowUrl: markerShadow,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  tooltipAnchor: [16, -28],
  shadowSize: [41, 41]
});

L.Marker.prototype.options.icon = DefaultIcon;

const Home = () => {
  const [sensorData, setSensorData] = useState([]);
  const [selectedMarker, setSelectedMarker] = useState(null);
  const [visitorCount, setVisitorCount] = useState(null);

  const fetchItems = async () => {
    try {
      const response = await api.get('/prediction/');
      setSensorData(response.data);
    } catch (error) {
      console.error('Error fetching items:', error);
    }
  };

  useEffect(() => {
    fetchItems();
  }, []);
  
  useEffect(() => {
	axios.post('http://128.95.204.84:8081/track-visitor')
	.then(() => {
	console.log('Visitor tracked');
	return axios.get('http://128.95.204.84:8081/visitors/count');
	})
	.then((res) => {
	setVisitorCount(res.data.visitor_count);
	})
	.catch((error) => {
	console.error('Visitor tracking failed:', error);
	});
	}, []);

  useEffect(() => {
    console.log('sensorData:', sensorData);
  }, [sensorData]);

  return (
    <div className="app-container">
      {/* Top Header */}
      <header className="top-bar">
        <div className="top-bar-content">
          <img src={logo} alt="Logo" className="header-logo" />
        </div>
      </header>

      <div className="main-container">
        {/* Main Content */}
        <div className="content">
		<div>
          <h1 className="page-header">
            FMCSA Truck Parking and Prediction
          </h1>

          {/* Description */}
          <div className="page-description">
            <p> Interactive map of truck parking sites, displaying real-time availability and predictions. <a href="https://www.surveymonkey.com/r/2LLMC6C" target="_blank" rel="noopener noreferrer">
                Click here &nbsp; </a> for the feedback survey. To receive updates about TPIMS, <a href="https://public.govdelivery.com/accounts/WADOT/subscriber/new?topic_id=WADOT_777 " target="_blank" rel="noopener noreferrer">
                sign up here&nbsp;
              </a>.
            </p>
          </div>
		  </div>
		  
		  {/* ✅ GOOGLE MAP SECTION */}
			<div className="map-fullscreen">
  <APIProvider apiKey={process.env.REACT_APP_GOOGLE_MAPS_KEY}>
    <Map
      defaultZoom={7}
      defaultCenter={{ lat: 47.6062, lng: -122.3321 }}
      mapId="b0d87f8b3dfefdf5"
      style={{ width: '100%', height: '100%' }}
	  options={{
		gestureHandling: 'greedy'  // 👈 allows one-finger dragging
	  }}
    >
      {sensorData
        .filter(
          (data) =>
            data.latitude !== undefined &&
            data.longitude !== undefined &&
            !isNaN(data.latitude) &&
            !isNaN(data.longitude)
        )
        .map((data) => (
          <AdvancedMarker
            key={data.siteId}
            position={{ lat: data.latitude, lng: data.longitude }}
            onClick={() => {
			  if (comingSoonSites.includes(data.siteId)) {
				setSelectedMarker({ ...data, comingSoon: true });
			  } else {
				setSelectedMarker({ ...data, comingSoon: false });
			  }
			}}
          >
            <Pin
              background={'#FBBC04'}
              glyphColor={'#000'}
              borderColor={'#000'}
            />
          </AdvancedMarker>
        ))}

      {selectedMarker && (
        <InfoWindow
  position={{ lat: selectedMarker.latitude, lng: selectedMarker.longitude }}
  onCloseClick={() => setSelectedMarker(null)}
>
  <div style={{ maxWidth: '300px' }}>
    <strong>{selectedMarker.siteName}</strong>
    <br />

    {comingSoonSites.includes(selectedMarker.siteId) ? (
  <>
    <p style={{ color: 'gray', marginTop: '0.5rem' }}>
      🚧 This site is currently under validation.
    </p>
    <p style={{ color: 'gray' }}>
      🕓 Data will be available soon.
    </p>
  </>
) : selectedMarker.trustData === false || selectedMarker.trustData === 'false' ? (
  <>
    <p style={{ color: 'gray', marginTop: '0.5rem' }}>
      🚧 This site is currently under maintenance.
    </p>
    <p style={{ color: 'gray' }}>
      ⚠️ Real-time data is not available at the moment.
    </p>
  </>
) : (
  <>
    Reported Available:
    <span
      style={{
        color: (() => {
          const available = selectedMarker.reportedAvailable;
          const capacity = selectedMarker.capacity;
          if (available == null || capacity == null || capacity === 0) return '#808080';
          const percent = (available / capacity) * 100;
          if (percent < 20) return '#377eb8';
          if (percent < 60) return '#ff7f00';
          return '#4daf4a';
        })(),
      }}
    >
      &nbsp;
      {selectedMarker.reportedAvailable != null && selectedMarker.capacity
        ? (() => {
            const percent = (selectedMarker.reportedAvailable / selectedMarker.capacity) * 100;
            let emoji = '🔺';
            if (percent < 20) emoji = '🔻';
            else if (percent < 60) emoji = '➖';
            return `${selectedMarker.reportedAvailable} ${emoji}`;
          })()
        : 'N/A'}
    </span>
    <br />
    Capacity: {selectedMarker.capacity ?? 'N/A'}
    <br />
    <br />
    Prediction (Accuracy):<br />
    {[
      { label: '10m', pre: selectedMarker.pre_10m, acc: selectedMarker.acc_10m },
      { label: '30m', pre: selectedMarker.pre_30m, acc: selectedMarker.acc_30m },
      { label: '1h', pre: selectedMarker.pre_1h, acc: selectedMarker.acc_1h },
      { label: '2h', pre: selectedMarker.pre_2h, acc: selectedMarker.acc_2h },
      { label: '3h', pre: selectedMarker.pre_3h, acc: selectedMarker.acc_3h },
      { label: '4h', pre: selectedMarker.pre_4h, acc: selectedMarker.acc_4h },
      { label: '6h', pre: selectedMarker.pre_6h, acc: selectedMarker.acc_6h },
      { label: '8h', pre: selectedMarker.pre_8h, acc: selectedMarker.acc_8h },
    ].map((item) => (
      <div key={item.label}>
        {item.label} =
        {item.pre != null && selectedMarker.capacity ? (
          <span
            style={{
              color: (() => {
                const percent = (item.pre / selectedMarker.capacity) * 100;
                if (percent < 20) return '#377eb8';
                if (percent < 60) return '#ff7f00';
                return '#4daf4a';
              })(),
            }}
          >
            {item.pre}
          </span>
        ) : (
          <span style={{ color: 'gray' }}>N/A</span>
        )}
        <span style={{ color: '#808080' }}>
          {item.pre != null && selectedMarker.reportedAvailable != null
            ? ` (±${Math.abs(item.pre - selectedMarker.reportedAvailable).toFixed(1)})`
            : ' (N/A)'}
        </span>
      </div>
    ))}
    <br />
    <br />
    Last Update:{' '}
    {selectedMarker.timeRequest
      ? new Date(selectedMarker.timeRequest).toLocaleString('en-US', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
        })
      : 'N/A'}
    <br />
    TrustData: {selectedMarker.trustData ?? 'N/A'}
  </>
)}
  </div>
</InfoWindow>
      )}
    </Map>
  </APIProvider>
</div>

        </div>
      </div>

      {/* Bottom Bar */}
      <footer className="bottom-bar">
        <p>Copyright © WSDOT | Privacy Policy | Disclaimer <span style={{ marginLeft: '10px' }}>
      Visitors: {visitorCount !== null ? visitorCount : '...'}
    </span></p>
      </footer>
    </div>
  );
};

export default Home;
